import React, { useState, useEffect } from 'react';

const LoadingOverlay = () => {
    const [showDonationMessage, setShowDonationMessage] = useState(false);

    useEffect(() => {
        // Show donation message after 3 seconds
        const timer = setTimeout(() => {
            setShowDonationMessage(true);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            // background: 'linear-gradient(45deg, #6c00a2, #ff5e62)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            padding: '20px',
            boxSizing: 'border-box'
        }}>
            <div style={{
                width: '50px',
                height: '50px',
                border: '3px solid rgba(255, 255, 255, 0.3)',
                borderTop: '3px solid white',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginBottom: '20px',
            }} />
            <div style={{
                color: 'white',
                fontSize: '18px',
                fontFamily: 'Arial',
                textAlign: 'center',
                marginBottom: '10px'
            }}>
                Loading musician connections...
            </div>

            {/* Donation message directly under loading text */}
            {showDonationMessage && (
                <div style={{
                    color: 'white',
                    fontSize: '18px',
                    fontFamily: 'Arial',
                    textAlign: 'center',
                    marginBottom: '20px',
                    animation: 'fadeIn 1s ease-in'
                }}>
                    This site runs on donations, consider checking out my{' '}
                    <a
                        href="https://ko-fi.com/PimvH"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: '#13c3ff',
                            textDecoration: 'none',
                            fontWeight: 'bold',
                            transition: 'color 0.3s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.color = '#47abcdff'}
                        onMouseLeave={(e) => e.target.style.color = '#4bc9f3ff'}
                    >
                        Ko-fi page
                    </a>
                </div>
            )}

            {/* AdSense Ad during loading */}
            {/* <LoadingAd /> */}

            <style>
                {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
                
                @keyframes fadeIn {
                  0% { 
                    opacity: 0; 
                    transform: translateY(10px); 
                  }
                  100% { 
                    opacity: 1; 
                    transform: translateY(0); 
                  }
                }
              `}
            </style>
        </div>
    );
};

export default LoadingOverlay;